import { DictionaryEntry } from '@sdbn/common';
import { MasterDetailListEntry } from "@sdbn/common";

export class DocumentTemplate implements MasterDetailListEntry {
  id: number;
  nameDictionaryKey: string;
  translatedName: string;

  constructor(template: any) {
    this.id = template.id;
    this.nameDictionaryKey = template.nameDictionaryKey;
  }

  public get listTitle(): string {
    return this.translatedName;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}

export enum TemplateSource {
  TASK = 'TASK'
}

export class DocumentTemplateDetails {

  dirty = false;
  invalid = false;
  structureInvalid = false;
  propertiesInvalid = false;

  id: number;
  name = new DictionaryEntry();
  titlePattern: string;
  source: TemplateSource;
  selectDefinitions = new Array<SelectDefinition>();
  areas = new Array<TemplateArea>();

  constructor(details?: DocumentTemplateDetails) {
    if (details != null) {
      this.id = details.id;
      this.name = new DictionaryEntry(details.name);
      this.titlePattern = details.titlePattern;
      this.source = details.source;

      if (details.selectDefinitions != null) {
        for (const a of details.selectDefinitions) {
          this.selectDefinitions.push(new SelectDefinition(a));
        }
      }

      if (details.areas != null) {
        for (const a of details.areas) {
          this.areas.push(new TemplateArea(a));
        }
      }
    }
    this.validate();
  }

  public validate() {

    let invalid = false;
    let structureInvalid = false;
    let propertiesInvalid = false;

    for (const definition of this.selectDefinitions) {

      definition.invalid = false;

      if (this.isNullOrEmpty(definition.identifier)) {
        invalid = true;
        propertiesInvalid = true;
        definition.invalid = true;
      }

      for (const option of definition.options) {

        option.invalid = false;

        if (this.isNullOrEmpty(option.value)) {
          invalid = true;
          propertiesInvalid = true;
          definition.invalid = true;
          option.invalid = true;
        }

        for (const av of option.attributeValues) {
          if (this.isNullOrEmpty(av.key) || this.isNullOrEmpty(av.value)) {
            invalid = true;
            propertiesInvalid = true;
            definition.invalid = true;
            option.invalid = true;
            av.invalid = true;
          }
        }
      }
    }

    for (const a of this.areas) {
      a.invalid = false;

      if (a.columnCount == null || a.columnCount <= 0) {
        invalid = true;
        structureInvalid = true;
        a.invalid = true;
      }
      if (this.isNullOrEmpty(a.style)) {
        invalid = true;
        structureInvalid = true;
        a.invalid = true;
      }

      for (const f of a.fields) {

        f.invalid = false;

        if (this.isNullOrEmpty(f.key)) {
          invalid = true;
          structureInvalid = true;
          a.invalid = true;
          f.invalid = true;
        }
        if (f.mode == null) {
          invalid = true;
          structureInvalid = true;
          a.invalid = true;
          f.invalid = true;
        }
        if (f.type == null) {
          invalid = true;
          structureInvalid = true;
          a.invalid = true;
          f.invalid = true;
        }
        if (f.type === TemplateFieldType.SELECT && this.isNullOrEmpty(f.selectDefinitionUuid)) {
          invalid = true;
          structureInvalid = true;
          a.invalid = true;
          f.invalid = true;
        }
      }
    }

    this.propertiesInvalid = propertiesInvalid;
    this.structureInvalid = structureInvalid;
    this.invalid = invalid;
  }

  private isNullOrEmpty(value: string): boolean {
    return value == null || value.trim().length === 0;
  }
}


export class TemplateArea {
  uuid: string;
  title = new DictionaryEntry();
  help = new DictionaryEntry();
  index: number;
  style: string;
  choice: string;
  columnCount: number;
  fields = new Array<TemplateField>();

  invalid = false;

  // Hilfsvariablen
  rowCount = 0;

  constructor(area?: TemplateArea) {
    if (area != null) {
      this.uuid = area.uuid;
      this.title = new DictionaryEntry(area.title);
      this.help = new DictionaryEntry(area.help);
      this.index = area.index;
      this.style = area.style;
      this.choice = area.choice;
      this.columnCount = area.columnCount;

      if (area.fields) {
        for (const f of area.fields) {
          this.fields.push(new TemplateField(f));
        }
      }
    }
  }
}

export enum TemplateFieldMode {
  DEFAULT = 'DEFAULT', DISABLED = 'DISABLED', HIDDEN = 'HIDDEN'
}

export enum TemplateFieldType {
  STRING = 'STRING', NUMBER = 'NUMBER', PHOTO = 'PHOTO',
  BOOLEAN = 'BOOLEAN', BOOLEAN_MANDATORY = 'BOOLEAN_MANDATORY', SELECT = 'SELECT', TEXT = 'TEXT', LABEL = 'LABEL'
}

export class TemplateField {
  uuid: string;
  key: string;
  defaultValue: string;
  label = new DictionaryEntry();
  required: boolean;
  type = TemplateFieldType.STRING;
  selectDefinitionUuid: string;
  mode = TemplateFieldMode.DEFAULT;
  style: any;
  row: number;
  column: number;
  colSpan: number;

  invalid = false;

  constructor(field?: TemplateField) {
    if (field != null) {
      this.uuid = field.uuid;
      this.key = field.key;
      this.defaultValue = field.defaultValue;
      this.label = new DictionaryEntry(field.label);
      this.required = field.required;
      this.type = field.type;
      this.selectDefinitionUuid = field.selectDefinitionUuid;
      this.mode = field.mode;
      this.style = field.style;
      this.row = field.row;
      this.column = field.column;
      this.colSpan = field.colSpan;
    }
  }
}

export class AttributeValue {
  key: string;
  value: string;

  invalid = false;

  constructor(av?: AttributeValue) {
    if (av != null) {
      this.key = av.key;
      this.value = av.value;
    }
  }
}


export class SelectOption implements MasterDetailListEntry {
  value: string;
  sortorder: number;
  attributeValues: AttributeValue[] = [];

  invalid = false;

  constructor(selectOption?: SelectOption) {
    if (selectOption != null) {
      this.value = selectOption.value;
      this.sortorder = selectOption.sortorder;

      if (selectOption.attributeValues != null) {
        for (const av of selectOption.attributeValues) {
          this.attributeValues.push(new AttributeValue(av));
        }
      }
    }
  }

  public get listTitle(): string {
    return this.value;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}

export class SelectDefinition implements MasterDetailListEntry {
  uuid: string;
  identifier: string;
  options = new Array<SelectOption>();

  invalid = false;

  constructor(definition?: SelectDefinition) {
    if (definition != null) {

      this.uuid = definition.uuid;
      this.identifier = definition.identifier;

      if (definition.options != null) {
        for (const o of definition.options) {
          this.options.push(new SelectOption(o));
        }
      }
    }
  }

  public get listTitle(): string {
    return this.identifier;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}

// START DTOs zum Speichern
export class SaveDocumentTemplate {

  id: number;
  name = new DictionaryEntry();
  titlePattern: string;

  selectDefinitions = new Array<SelectDefinition>();
  areas = new Array<SaveTemplateArea>();

  constructor(details?: DocumentTemplateDetails) {
    if (details != null) {
      this.id = details.id;
      this.name = new DictionaryEntry(details.name);
      this.titlePattern = details.titlePattern;

      if (details.selectDefinitions != null) {
        for (const a of details.selectDefinitions) {
          this.selectDefinitions.push(new SelectDefinition(a));
        }
      }

      if (details.areas != null) {
        for (const a of details.areas) {
          this.areas.push(new SaveTemplateArea(a));
        }
      }
    }
  }
}

export class SaveTemplateArea {
  uuid: string;
  title = new DictionaryEntry();
  help = new DictionaryEntry();
  index: number;
  style: string;
  choice: string;
  columnCount: number;

  // Hilfsvariablen?
  fields = new Array<SaveTemplateField>();

  constructor(area?: TemplateArea) {
    if (area != null) {
      this.uuid = area.uuid;
      this.title = new DictionaryEntry(area.title);
      this.help = new DictionaryEntry(area.help);
      this.index = area.index;
      this.style = area.style;
      this.choice = area.choice;
      this.columnCount = area.columnCount;

      if (area.fields) {
        for (const f of area.fields) {
          this.fields.push(new SaveTemplateField(f));
        }
      }
    }
  }
}

export class SaveTemplateField {
  uuid: string;
  key: string;
  defaultValue: string;
  label = new DictionaryEntry();
  required: boolean;
  type = TemplateFieldType.STRING;
  selectDefinitionUuid: string;
  mode = TemplateFieldMode.DEFAULT;
  style: string;
  row: number;
  column: number;
  colSpan: number;

  constructor(field?: TemplateField) {
    if (field != null) {
      this.uuid = field.uuid;
      this.key = field.key;
      this.defaultValue = field.defaultValue;
      this.label = new DictionaryEntry(field.label);
      this.required = field.required;
      this.type = field.type;
      this.selectDefinitionUuid = field.selectDefinitionUuid;
      this.mode = field.mode;
      this.style = 'grid-row: ' + field.row * 2 + ', grid-column: ' + field.column + ' / span ' + field.colSpan;
      this.row = field.row;
      this.column = field.column;
      this.colSpan = field.colSpan;
    }
  }
}
// END DTOs zum Speichern
